const Abort = (() => {
  let instance: AbortController

  return {
    getInstance: () => {
      if (!instance) {
        instance = new AbortController()
      }

      return instance
    },
  }
})()

export default Abort
